import React from 'react';
import './KickstarterWidget.css';
import KikSvgImage from './KikSvgImage';
import KikSvgImageMini from './KikSvgMini';

export const KickstarterWidget = () => {
    return (
        <div className='ks-overlay-wrapper'>
            <a
                href="https://www.kickstarter.com/projects/gardenofdreamsgames/silicone-heart"
                target="_blank"
                rel="noreferrer"
                className="ks-svg-link"
            >
                <div className="kickDesktop">
                    <KikSvgImage className="kikSvg" />
                </div>

                <div className="kickMobile">
                </div>
            </a>

        </div>
    );
};